"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutsideClick = useOutsideClick;
var _react = require("react");
var _addOutsideClick = _interopRequireDefault(require("../utils/addOutsideClick"));
function useOutsideClick(element, onOutsideClick) {
  (0, _react.useEffect)(function () {
    if (!element) {
      return;
    }
    var removeOnOutsideClick = (0, _addOutsideClick["default"])(element, onOutsideClick);
    return function () {
      return removeOnOutsideClick();
    };
  }, [element, onOutsideClick]);
}